import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RetailerRoutingModule } from './retailer-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DetailLegacyComponent } from './detail-legacy/detail-legacy.component';
import { SwiperModule } from 'swiper/angular';
import { MatTabsModule } from '@angular/material/tabs';
import { RewardComponent } from './detail-legacy/reward/reward.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DirectiveModule } from '@directives/directive.module';
import { ComponentsModule } from '@shared/components/components.module';
import { CKEditorModule } from 'ckeditor4-angular';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { MatMenuModule } from '@angular/material/menu';
import { DistributorModule } from '../distributor/distributor.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PendingRegistrationComponent } from './pending/pending-registration/pending-registration.component';
import { PendingSubmissionComponent } from './pending/pending-submission/pending-submission.component';
import { MacRegistrationComponent } from './mac-registration/mac-registration.component';
import { MatButtonModule } from '@angular/material/button';
import { InputListboxCakupanWilayahComponent } from './components/input-listbox-cakupan-wilayah/input-listbox-cakupan-wilayah.component';
import { ProductsModule } from '../products/products.module';
import { ModalConfirmRegisterComponent } from './components/modal-confirm-register/modal-confirm-register.component';
import { RetailerListComponent } from './components/retailer-list/retailer-list.component';
import { MatRadioModule } from '@angular/material/radio';
import { GoogleMapsModule } from '@angular/google-maps';
import { RetailerGmapComponent } from './components/retailer-gmap/retailer-gmap.component';
import { ProgramMarketingListComponent } from './components/program-marketing-list/program-marketing-list.component';
import { TerverifikasiActiveComponent } from './terverifikasi/terverifikasi-active/terverifikasi-active.component';
import { TerverifikasiNonactiveComponent } from './terverifikasi/terverifikasi-nonactive/terverifikasi-nonactive.component';

@NgModule({
  declarations: [
    DetailLegacyComponent,
    RewardComponent,
    PendingRegistrationComponent,
    PendingSubmissionComponent,
    MacRegistrationComponent,
    InputListboxCakupanWilayahComponent,
    ModalConfirmRegisterComponent,
    RetailerListComponent,
    RetailerGmapComponent,
    ProgramMarketingListComponent,
    TerverifikasiActiveComponent,
    TerverifikasiNonactiveComponent,
  ],
  exports: [PendingRegistrationComponent, PendingSubmissionComponent, InputListboxCakupanWilayahComponent, RetailerListComponent],
  imports: [
    CommonModule,
    RetailerRoutingModule,
    DirectiveModule,
    MatTableModule,
    MatSortModule,
    InlineSVGModule,
    NgxSkeletonLoaderModule,
    SwiperModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    ComponentsModule,
    CKEditorModule,
    NgbPopoverModule,
    MatMenuModule,
    DistributorModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    ProductsModule,
    MatRadioModule,
    GoogleMapsModule,
  ],
})
export class RetailersModule {}
